import { mock } from '../constants/mocks/enable';
import { personMock } from '../constants/mocks/personMock';
import ENABLE from '../constants/enable';
import Service from './abstract';
import _ from 'lodash';

const DEFAULT_ID_STORE = 1;

// const defaultWith = 'person,person.attributes,person.attributes.attribute,person.documents,addresses,files,requests';

const defaultWithLoans = 'sign_request,loan_request,sign_request.person,sign_request.person.attributes,sign_request.person.attributes.attribute,sign_request.person.telephones,sign_request.person.documents,loan_request.external_person';

const requestsBills = 'loanRequestsFiles,loanRequestsFiles.file';

const defaultOptionsFind = {
    order: 'created_at-DESC',
    with: defaultWithLoans, // defaultWith,
    pageSize: 10
};

const defaultBillsList = {
    order: 'created_at-DESC',
    with: requestsBills, // defaultWith,
    pageSize: 10
};

class CuotitasStore extends Service {
    constructor () {
        super('cuotitasstores');
        // this.basePath = 'http://localhost:64055';
    }

    createLoanAndSign (id, data, qs) {
        // Enable Mock only in development
        if (ENABLE?.enableMock && mock?.loanFlow?.postRequest?.enable) {
            return mock?.loanFlow?.postRequest?.response;
        }

        return this.post({
            url: `${this.basePath}/stores/${id}/requests`,
            data,
            qs
        });
    }

    //
    // Stores
    //
    getStores (data = {}) {
        return this.get({
            url: `${this.basePath}/stores`,
            qs: _.defaultsDeep({}, data, defaultOptionsFind),
        });
    }

    getStoresById (id) {
        return this.get({
            url: `${this.basePath}/stores/${id}/cuotitasrequests`,
            qs: {
                filters: `id_store eq ${id}`,
                with: 'sign_request,loan_request,sign_request.person,sign_request.person.attributes,loan_request.external_person'
            },
        });
    }

    getStoreLoans (id, data) {
        return this.get({
            url: `${this.basePath}/stores/${id}/cuotitasrequests`,
            qs: _.defaultsDeep({}, data, defaultOptionsFind),
        });
    }

    createMultipart (data) {
        return this.post({
            // se está usando en crear commercio
            url: `${this.basePath}/stores`,
            data
        });
    }

    getStoreById (data, id) {
        return this.get({
            url: `${this.basePath}/stores/${id}`,
            qs: _.defaultsDeep({}, data, defaultOptionsFind),
        });
    }

    getStoreLoanRequests (storeId, options) {
        return this.get({
            url: `${this.basePath}/stores/${storeId}/requests`,
            qs: _.defaultsDeep({}, options),
        });
    }

    getRequestsList (options) {
        return this.get({
            url: `${this.basePath}/requests`,
            qs: _.defaultsDeep({}, options, defaultBillsList),
        });
    }

    getPerson (qs, async) {
        // Enable Mock only in development
        if (ENABLE?.enableMock && mock?.loanFlow?.putPeople?.enable) {
            return mock?.loanFlow?.putPeople?.response;
        }

        return this.put({
            url: `${this.basePath}/people`,
            qs: _.defaultsDeep({}, qs, async),
        });
    }

    getPersonByDocument (document) {
        // Enable Mock only in development
        if (ENABLE?.enableMock && mock?.loanFlow?.personByDocumentExample1?.enable) {
            return mock?.loanFlow?.personByDocumentExample1?.response;
        }

        if (ENABLE?.enablePersonBankMock) {
            return personMock(document);
        }

        return this.get({
            url: `${this.basePath}/people/genreIdentifier/${document}`
        });
    }

    getSocket () {
        return this.get({ url: `${this.basePath}/socket` });
    }

    createOrModifyUser (data, qs) {
        // Enable Mock only in development
        if (ENABLE?.enableMock && mock?.loanFlow?.postPeopleComplete?.enable) {
            return mock?.loanFlow?.postPeopleComplete?.response;
        }

        return this.post({
            url: `${this.basePath}/people`,
            data,
            qs
        });
    }

    getInstallmentsByOffer (idStore, idOffer, capitalRequest) {
        idStore = idStore || DEFAULT_ID_STORE;
        // Enable Mock only in development
        if (ENABLE?.enableMock && mock?.loanFlow?.getInstallments?.enable) {
            return mock?.loanFlow?.getInstallments?.response;
        }

        const queryParams = capitalRequest ? { capitalRequest } : {};
        const url = `${this.basePath}/stores/${idStore}/offers/${idOffer}/installments`;

        return this.get({
            url,
            qs: queryParams
        });
    }

    /**
     * Is api/ecommerce/ValidarCliente
     */
    createOffer (idStore, data, qs) {
        // Enable Mock only in development
        if (ENABLE?.enableMock && mock?.loanFlow?.postOffers?.enable) {
            return mock?.loanFlow?.postOffers?.response;
        }

        return this.post({
            url: `${this.basePath}/stores/${idStore}/offers`,
            data,
            qs
        });
    }

    /**
     * Is api/ecommerce/ObtenerParametros
     */
    getPoliticies (data = {}) {
        // Enable Mock only in development
        if (ENABLE?.enableMock && mock?.loanFlow?.getPolicies?.enable) {
            return mock?.loanFlow?.getPolicies?.response;
        }

        return this.get({
            url: `${this.basePath}/stores/policies`,
            // qs: _.defaultsDeep({}, data),
        });
    }

    /**
     * Is confirmarPrestamo
     */
    confirmLoanRequest (id, idRequest, qs, data) {
        // requests (loans)
        return this.post({
            url: `${this.basePath}/stores/${id}/requests/${idRequest}/confirm`,
            data,
            qs,
        });
    }

    sendSMS (data) {
        // Enable Mock only in development
        if (ENABLE?.enableMock && mock?.loanFlow?.postNotification?.enable) {
            return mock?.loanFlow?.postNotification?.response;
        }

        return this.post({
            url: `${this.basePath}/notifications`,
            data,
        });
    }

    sendToken (data, qs) {
        // Enable Mock only in development
        if (ENABLE?.enableMock && mock?.loanFlow?.postVerify?.enable) {
            return mock?.loanFlow?.postVerify?.response;
        }

        return this.post({
            url: `${this.basePath}/device/verify`,
            data,
            qs
        });
    }

    validateToken (data) {
        // Enable Mock only in development
        if (ENABLE?.enableMock && mock?.loanFlow?.postValidate?.enable) {
            return mock?.loanFlow?.postValidate?.response;
        }

        return this.post({
            url: `${this.basePath}/device/validate`,
            data,
        });
    }

    getActivities (data = {}) {
        // Enable Mock only in development
        if (ENABLE?.enableMock && mock?.loanFlow?.getActivities?.enable) {
            return mock?.loanFlow?.getActivities?.response;
        }

        return this.get({
            url: `${this.basePath}/stores/activities`,
            qs: _.defaultsDeep({}, data),
        });
    }

    getLoanFiles (id) {
        return this.get({
            url: `${this.basePath}/files/${id}`
        });
    }

    // validate CBU/CVU o Alias
    getAccountByCVU (cbucvu, data) {
        return this.get({
            url: `${this.basePath}/accounts/validate/cvu/${cbucvu}`,
            qs: _.defaultsDeep({}, data),
        });
    }

    getLoanRequestCheckbook (loanRequestId, tab) {
        return this.get({
            url: `${this.basePath}/stores/requests/${loanRequestId}/files/checkbooks`,
            qs: {
                fileFormat: 'base64',
                tab,
            }
        });
    }

    registerLoanLogsError (error, errorInfo = {}) {
        const body = {
            from: 'WEB01',
            method: 'GET',
            path: window.location.pathname,
            error: {
                name: error.name,
                message: error.message,
                stack: errorInfo.componentStack || error.stack
            },
        };

        return this.post({
            url: `${this.basePath}/loanlogs/error`,
            body
        });
    }

    uploadLoanBill (idStore, idLoanRequest, data) {
        return this.put({
            url: `${this.basePath}/stores/${idStore}/requests/${idLoanRequest}/bill`,
            data
        });
    }

    getBusinessPlansInstalments (data) {
        return this.get({
            url: `${this.basePath}/businessplans/installments`,
            data
        });
    }
}

export default new CuotitasStore();
